import './ContainerMain.css';

const ContainerMain = ({ children }) => <div className="container-password-main">{children}</div>;

export default ContainerMain;
